import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { PAGES } from '../../constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { SuppliersList } from './components/SuppliersList';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

export const Suppliers = () => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.suppliers} />
                </HeaderTitle>
                <ButtonsContainer>
                    <Link to={PAGES.supplierCreate.url}>
                        <TotemPrimaryButton>Créer un fournisseur</TotemPrimaryButton>
                    </Link>
                </ButtonsContainer>
            </Header>
            <Content>
                <SuppliersList />
            </Content>
        </Container>
    );
};

const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
`;
